import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=bb7133b0&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=bb7133b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7133b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb7133b0')) {
      api.createRecord('bb7133b0', component.options)
    } else {
      api.reload('bb7133b0', component.options)
    }
    module.hot.accept("./LoginPage.vue?vue&type=template&id=bb7133b0&scoped=true", function () {
      api.rerender('bb7133b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/LoginPage.vue"
export default component.exports